import { useQuery } from "@tanstack/vue-query";

import { queries } from "~/queries";

/**
 * Composable for 360° product viewer configuration
 * @returns Object with demo configuration for 360° viewer
 */
export const use360Viewer = (productIdentifier: MaybeRefOrGetter<string>) => {
  const platformStore = usePlatformStore();
  const platformId = computed(
    () => platformStore.getPlatformConfiguration.platformId,
  );

  const { data: productDetails } = useQuery(
    queries.products.details(productIdentifier, platformId),
  );

  const image360Url = computed(() => {
    if (!productDetails.value?.image360Url) return undefined;

    // 360° image URLs end with '36.jpg', which is a convention for the last frame in a 36-frame sequence.
    return productDetails.value?.image360Url.replace(/36\.jpg$/, "");
  });

  const { result: shouldShow360, loaded: growthbookLoaded } = useGrowthbook({
    feature: "360-images-web",
    fallback: false,
  });

  const has360Images = computed(() => {
    if (!growthbookLoaded.value) return false;

    return shouldShow360.value && !!image360Url.value?.length;
  });

  return {
    image360Url,
    has360Images,
  };
};
